<div class="app-container">
  <page-header
    [title]="isCreating() ? 'purchase.new' : ('purchase.detail' | translate) + ' ' + queryPurchaseOrder.data()?.number"
  >
    @if (!loading() && !isCreating()) {
      <ng-container class="custom-title">
        <div
          class="status-div margin-left"
          [ngClass]="'status-' + queryPurchaseOrder.data()?.status?.id"
          [title]="queryPurchaseOrder.data()?.status?.name | translate"
        >
          {{ queryPurchaseOrder.data()?.status?.name | translate }}
        </div>
      </ng-container>
    }
    <ng-container class="header-button">
      <btn
        [label]="'save'"
        [title]="'save' | translate"
        [classes]="['btn-first']"
        [icon]="'far-check'"
        [spinnerClassesString]="'spinner-white'"
        [btnType]="'submit'"
        (click)="isCreating() ? mutationCreatePurchaseOrder.mutate() : mutationUpdatePurchaseOrder.mutate()"
        [btnDisabled]="
          !(
            this.purchaseOrderForm.value.dateEstimatedArrival &&
            this.purchaseOrderForm.value.supplier &&
            this.purchaseOrderForm.value.depot
          ) || this.areFilesUploading
        "
        [dataCyAttribute]="'create-purchase-order-button'"
      ></btn>
      @if (!isCreating() && queryPurchaseOrder.data()?.deletable) {
        <btn
          [label]="'purchase-order.delete-label'"
          [title]="'purchase-order.delete-label' | translate"
          [classes]="['btn-first-red', 'me-2', 'float-right']"
          [isLoading]="deletePurchaseOrder.isPending()"
          [icon]="'far-trash-alt'"
          (onEvent)="deletePurchaseOrder.mutate()"
          data-cy="delete-purchase-order"
        ></btn>
      }
      @if (queryPurchaseOrder.data()?.id > 0 && !isCreating()) {
        <dropdown
          [icon]="'fas-chevron-down'"
          [label]="'purchase-order.export.dropdown-label'"
          [items]="[
            { action: 'excelUrl', label: 'purchase-order.export.excel-with-prices', isSelected: false },
            { action: 'excelWOPricesUrl', label: 'purchase-order.export.excel-without-prices', isSelected: false },
            { action: 'pdfUrl', label: 'purchase-order.export.pdf-with-prices', isSelected: false },
            { action: 'pdfWOPricesUrl', label: 'purchase-order.export.pdf-without-prices', isSelected: false }
          ]"
          [isArrowHidden]="false"
          [autoClose]="true"
          [classes]="['btn-third', 'me-2', 'float-right', 'dropdown-toggle']"
          (onResult)="download($event)"
        ></dropdown>
      }
      @if (!isCreating()) {
        <modal-loggable-history
          [objectClass]="'PurchaseOrder'"
          [objectId]="queryPurchaseOrder.data()?.id"
        ></modal-loggable-history>
      }
    </ng-container>
    <ng-container class="back-button">
      <btn
        [label]="'back'"
        [title]="'back' | translate"
        [isBackButton]="true"
        [classes]="['btn-third', 'float-right', 'me-2']"
        [icon]="'far-arrow-left'"
        [routerLink]="['/purchase-orders']"
      ></btn>
    </ng-container>
  </page-header>
  <section class="content">
    <loading-spinner [isLoading]="loading()" [classesString]="'top-25'"></loading-spinner>
    @if (!loading()) {
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-8 h-25 ps-0">
          @if (isCreating() && skippedProductsMissingQuantityLevel().length) {
            <div class="skipped-products-warning" role="alert" data-cy="purchase-order-skipped-products">
              <div>
                <span class="skipped-products-warning-title">
                  {{
                    'purchase-order.skipped-products.title'
                      | translate: { count: skippedProductsMissingQuantityLevel().length }
                  }}
                </span>
                <p class="skipped-products-description">
                  {{ 'purchase-order.skipped-products.description' | translate }}
                </p>
              </div>
              <div class="skipped-products-list">
                @for (skippedProduct of skippedProductsMissingQuantityLevel(); track skippedProduct) {
                  <div class="skipped-products-item" data-cy="purchase-order-skipped-product-row">
                    <div>
                      <a
                        class="link-bold"
                        [routerLink]="['/product', skippedProduct.id]"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ skippedProduct.fullName }}
                      </a>
                      <div class="product-details flex-gap-5 flex-wrap">
                        @if (skippedProduct.code) {
                          <div>
                            {{ 'product.code' | translate }}:<span> {{ skippedProduct.code }}</span>
                          </div>
                        }
                        @if (skippedProduct.ean) {
                          <div>
                            {{ 'product.ean' | translate }}:<span> {{ skippedProduct.ean }}</span>
                          </div>
                        }
                      </div>
                    </div>
                    <span class="skipped-products-level">
                      {{ 'purchase-order.skipped-products.missing-level' | translate }}:
                      {{ skippedProduct.missingLevel | translate }}
                    </span>
                  </div>
                }
              </div>
            </div>
          }
          <div class="card">
            <div class="row">
              <div class="col-6 align-self-center">
                <span class="card-title text-nowrap">
                  {{ 'purchase.product-list' | translate }}
                </span>
              </div>
              <div class="col-6 d-flex flex-row-reverse">
                <modal-product-choose-purchase
                  [suppliers]="querySuppliers.data()"
                  (chosenProduct)="addProduct($event)"
                  data-cy="product-choose"
                ></modal-product-choose-purchase>
              </div>
            </div>
            @if (!purchaseOrderForm.value.items?.length) {
              <p class="text-align-center">{{ 'no.items' | translate }}</p>
            }
            @if (purchaseOrderForm.value.items?.length) {
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="ps-0">{{ 'product.name' | translate }}</th>
                      <th class="text-nowrap text-end">{{ 'purchase.prive-without-vat' | translate }}</th>
                      <th class="text-nowrap text-end">{{ 'numberOfItems' | translate }}</th>
                      <th class="text-nowrap text-end">{{ 'done' | translate }}</th>
                      <th class="text-nowrap text-end">{{ 'price.total' | translate }}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of purchaseOrderForm.value.items; track item) {
                      <tr
                        [ngClass]="
                          item.quantity === item.quantityIn
                            ? 'colorGrey'
                            : item.quantityIn > 0 && item.quantityIn < item.quantity
                              ? 'colorYellow'
                              : ''
                        "
                      >
                        <td class="ps-1 text-start">
                          <div class="flex-gap-10 align-items-center">
                            <div
                              [photoGallery]="item.product?.mainImage?.url"
                              [photoGalleryCaption]="
                                item.product?.fullName +
                                '<br>' +
                                (item.product?.code ? ('product.code' | translate) + item.product?.code : '') +
                                '<br>' +
                                (item.product?.ean ? ('product.ean' | translate) + item.product?.ean : '')
                              "
                            >
                              <div class="images-item">
                                @if (
                                  !!item.product?.mainImage?.url?.length &&
                                  !!item.product?.mainImage?.thumbnails?.length
                                ) {
                                  <img
                                    class="images-item-image"
                                    [src]="getThumbUrl(item.product?.mainImage)"
                                    [alt]="item.product?.fullName"
                                  />
                                }
                                @if (
                                  !item.product?.mainImage?.url?.length || !item.product?.mainImage?.thumbnails?.length
                                ) {
                                  <img
                                    class="images-item-image"
                                    [src]="'assets/img/no-image.png'"
                                    [alt]="item.product?.fullName"
                                  />
                                }
                              </div>
                            </div>
                            <div>
                              <a class="link-bold" [routerLink]="['/product', item.product?.id || item.product]">{{
                                item.product?.fullName
                              }}</a>
                              <div class="product-details flex-gap-5 flex-wrap">
                                @if (item.product?.code && item.product?.code.length > 0) {
                                  <div>
                                    {{ 'product.code' | translate }}:<span> {{ item.product?.code }}</span>
                                  </div>
                                }
                                @if (item.product?.ean && item.product?.ean.length > 0) {
                                  <div>
                                    {{ 'product.ean' | translate }}:<span> {{ item.product?.ean }}</span>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="text-end">{{ item.purchasePrice | formatPrice: getcurrency(item) }}</td>
                        <td class="text-end">{{ item.quantity | number: '1.0-2' | replaceCommaToDot }}</td>
                        <td class="text-end">{{ item.quantityIn | number: '1.0-2' | replaceCommaToDot }}</td>
                        <td class="text-end">{{ item.purchasePriceAll | formatPrice: getcurrency(item) }}</td>
                        <td class="text-end text-nowrap">
                          <modal-stock-operation-card-purchase
                            [isAddingNew]="false"
                            [editedItem]="item"
                            (result)="edit(item, $event)"
                          ></modal-stock-operation-card-purchase>
                          <btn
                            [ngClass]="{ invisible: !item.deletable }"
                            [title]="'delete' | translate"
                            [icon]="'far-trash-alt'"
                            [classes]="['btn-sm', 'btn-trash']"
                            (click)="remove(item)"
                          ></btn>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
          @if (!isCreating()) {
            <div class="card">
              <span class="card-title text-nowrap">
                {{ 'product.moves' | translate }}
              </span>
              <!--          todo items - which entity ???-->
              <app-base-listing
                [listName]="'productMovePacksPurchaseOrder'"
                [query]="queryProductMovePacks"
                [columns]="listingColumns"
                [selectedColumns]="listingColumns"
                [sortProp]="sortProp"
                [sortDir]="sortDir"
              ></app-base-listing>
            </div>
          }
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4 pe-0">
          <div class="card">
            <form [formGroup]="purchaseOrderForm">
              <form-row-select
                [label]="'purchase.depot-to'"
                [options]="queryDepotsOptions.data()"
                formControlName="depot"
                [formGroup]="purchaseOrderForm"
                [required]="true"
                [dataCyAttribute]="'purchaseOrder-depot'"
              ></form-row-select>
              <form-row-select
                [label]="'supplier'"
                [options]="querySuppliers.data()"
                formControlName="supplier"
                [formGroup]="purchaseOrderForm"
                [dataCyAttribute]="'purchaseOrder-supplier'"
                [required]="true"
              ></form-row-select>
              <form-row-input
                [label]="'purchase.reference'"
                [icon]="null"
                formControlName="externalReference"
                [formGroup]="purchaseOrderForm"
                [dataCyAttribute]="'purchaseOrder-externalReference'"
              ></form-row-input>
              <form-row-input
                [label]="'purchase.supplierReference'"
                [icon]="null"
                formControlName="supplierReference"
                [formGroup]="purchaseOrderForm"
                [dataCyAttribute]="'purchaseOrder-supplierReference'"
              ></form-row-input>
              @if (!isCreating()) {
                <form-row-input
                  [label]="'purchase.date-created'"
                  [icon]="null"
                  [inputType]="'date'"
                  [inputDisabled]="true"
                  formControlName="created"
                  [formGroup]="purchaseOrderForm"
                  [dataCyAttribute]="'purchaseOrder-created'"
                ></form-row-input>
              }
              <form-row-input
                [label]="'purchase.expected-date'"
                [icon]="null"
                [inputType]="'date'"
                [minimumVal]="purchaseOrderForm.value.created"
                formControlName="dateEstimatedArrival"
                [formGroup]="purchaseOrderForm"
                [required]="true"
                [dataCyAttribute]="'purchaseOrder-dateEstimatedArrival'"
              ></form-row-input>
              @if (!isCreating()) {
                <form-row-input
                  [label]="'createdBy'"
                  [icon]="null"
                  [model]="purchaseOrderForm.value.createdBy?.name"
                  [inputDisabled]="true"
                  [dataCyAttribute]="'purchaseOrder-createdBy'"
                ></form-row-input>
              }
              <form-row-select-multiple
                [label]="'tags'"
                [options]="queryTags.data()"
                [selectedValues]="purchaseOrderForm.value.tags"
                (selectedValuesChange)="tagsChanged($event)"
                [isTags]="true"
                [dataCyAttribute]="'purchaseOrder-tags'"
              ></form-row-select-multiple>
              <form-row-textarea
                [icon]="'far-note'"
                [label]="'note'"
                formControlName="note"
                [formGroup]="purchaseOrderForm"
                [dataCyAttribute]="'purchaseOrder-note'"
              ></form-row-textarea>
              <form-row-textarea
                [icon]="'far-note'"
                [label]="'note.private'"
                formControlName="privateNote"
                [formGroup]="purchaseOrderForm"
                [dataCyAttribute]="'purchaseOrder-privateNote'"
              ></form-row-textarea>
            </form>
          </div>
          <app-order-files
            [isOnPurchaseOrder]="true"
            [purchaseOrderForm]="purchaseOrderForm"
            (purchaseOrderFormChange)="purchaseOrderFormChanged($event)"
            [(isEditedFiles)]="isEditedFiles"
            (areFilesUploadingChange)="areFilesUploading = $event"
            (onFileAdded)="fileAdded($event)"
          >
          </app-order-files>
        </div>
      </div>
    }
  </section>
</div>
